module.exports = __webpack_public_path__ + "c042c09dbe275aa5ebc9f0a36dde792c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/von-dogen.png
// module id = Gq+q
// module chunks = 0